import { Button } from '@paguz/ui';
import { Link } from '@tanstack/react-router';
import { SparklesIcon, WalletIcon } from 'lucide-react';

/** Estado "sin cupo": invita a solicitar el crédito con el Asesor IA. */
export function NoLineState() {
  return (
    <section
      aria-label="Aún no tienes cupo"
      className="flex flex-col items-start gap-3 rounded-2xl bg-highlight-soft p-5 text-highlight-soft-foreground"
    >
      <span className="flex size-12 items-center justify-center rounded-full bg-card text-highlight">
        <WalletIcon className="size-6" aria-hidden />
      </span>
      <h2 className="text-xl">Aún no tienes cupo de crédito</h2>
      <p>
        Con tu cupo puedes pagarle a tus proveedores con QR Bre-B y diferir en cuotas. Tu Asesor IA
        te acompaña en la solicitud, sin filas ni papeleo.
      </p>
      <Button
        asChild
        variant="highlight"
        size="lg"
        className="h-auto min-h-12 w-full py-3 text-center whitespace-normal"
      >
        <Link to="/asesor">
          <SparklesIcon aria-hidden />
          Solicitar con el Asesor IA
        </Link>
      </Button>
    </section>
  );
}
